<dw-ui-dialog-box [title]="'Doc::CustomerSalesPurchase:ToDeliver'" (saveFn)="save()">
  <div>
    <document-delivery-note-creation-grid
      [lines]="lines"
      [salesPurchaseId]="salesPurchaseId"
      [allowPartialDelivery]="allowPartialDelivery()"
    ></document-delivery-note-creation-grid>
  </div>

  <div class="mt-1">
    <document-delivery-note-deposit-grid
      [lines]="lines"
      [salesPurchaseId]="salesPurchaseId"
      [allowPartialDelivery]="allowPartialDelivery()"
    ></document-delivery-note-deposit-grid>
  </div>

  <div class="mt-1">
    <document-delivery-note-packaging-grid
      [packagingList]="packagings"
    ></document-delivery-note-packaging-grid>
  </div>

  <document-invoicing-configuration
    [(generateInvoice)]="generateInvoice"
    [(invoicingDaybookId)]="invoicingDaybookId"
    [(invoicingPrintTemplateId)]="invoicingPrintTemplateId"
    [(sendInvoice)]="sendInvoice"
    [(invoiceEmailTemplateId)]="invoiceEmailTemplateId"
  ></document-invoicing-configuration>
</dw-ui-dialog-box>
